import { Plus } from "lucide-react";
import { MatterDefaultExpensesTable } from "@/components/features/settings/defaults/matter-default-expenses/MatterDefaultExpensesTable";
import { Button, Text } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import {
  ACTION_PERMISSION_KEYS,
  ACTION_PERMISSION_VALUES,
} from "@/lib/data/static/permissionOptions";
import { useState } from "react";

export default function MatterDefaultExpensesCard() {
  const { hasActionPermission } = useUser();
  const [isAddingExpense, setIsAddingExpense] = useState(false);

  const canCreateDefaultExpense = hasActionPermission(
    ACTION_PERMISSION_KEYS.defaultMatterExpense,
    ACTION_PERMISSION_VALUES.create,
  );

  return (
    <div className="w-full">
      <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="gap-y-1">
          <Text variant="title">Cost categories</Text>
        </div>
        {canCreateDefaultExpense ? (
          <Button
            variant="foreground"
            size="md"
            className="shrink-0"
            onClick={() => {
              setIsAddingExpense(true);
            }}
          >
            <Plus className="h-4 w-4" aria-hidden="true" />
            Add category
          </Button>
        ) : null}
      </div>
      <MatterDefaultExpensesTable
        isAddingExpense={isAddingExpense}
        setIsAddingExpense={setIsAddingExpense}
      />
    </div>
  );
}
